import React, { useState } from 'react';
import InfoIcon from './InfoIcon';
import InfoRow from './InfoRow';

const PriceCard = ({
	product,
	byMonth,
	popular,
	info,
	subscriptionFeatures,
	subscribedTo,
	scTrialAvailable,
	turnOnModal,
}) => {
	const [dropDown, setDropDown] = useState(false);
	const productList = ['Essential', 'Agency', 'Professional'];
	const subscriptionFeaturesIndex =
		productList.indexOf(product.product.name) + 2;

	const toggleDropDown = () => {
		setDropDown(!dropDown);
	};
	const closeDropDown = () => {
		setDropDown(false);
	};
	window.addEventListener('orientationchange', closeDropDown);

	let orderedPlans = product.plans.sort((a, b) => {
		if (a.interval === 'month') {
			return -1;
		}
		return 1;
	});

	const Button = () => {
		// special case to deal with late design change
		// professional does not show price (see invisible class below)
		// professional links to contact us page instead of stripe
		if (product.product.metadata.kind === 'sc_professional') {
			return (
				<a
					href={'https://sponsorcircle.com/contactus'}
					className={'purchase-button'}
				>
					<p>CONTACT US</p>
				</a>
			);
		}

		// is not subscribed
		if (!subscribedTo.plan_id) {
			return (
				<a
					href={
						'subscriptions/new?plan=' +
						orderedPlans[byMonth ? 0 : 1].id
					}
					className={'purchase-button'}
				>
					<p>SUBSCRIBE</p>
				</a>
			);
		}

		if (subscribedTo.product === product.product.name) {
			if (
				(byMonth && subscribedTo.interval === 'month') ||
				(!byMonth && subscribedTo.interval === 'year')
			) {
				return (
					<a
						onClick={() => {
							turnOnModal();
						}}
						className="purchase-button black"
					>
						<p>UNSUBSCRIBE</p>
					</a>
				);
			} else {
				return (
					<a
						href={
							'subscriptions/' +
							subscribedTo.sub_id +
							'?plan=' +
							orderedPlans[byMonth ? 0 : 1].id
						}
						className={'purchase-button hollow'}
					>
						<p>SWITCH BILLING</p>
					</a>
				);
			}
		}

		let buttonText = 'UPGRADE';
		if (
			productList.indexOf(product.product.name) <
			productList.indexOf(subscribedTo.product)
		) {
			buttonText = 'DOWNGRADE';
		}

		// is subscribed
		return (
			<a
				href={
					'subscriptions/' +
					subscribedTo.sub_id +
					'?plan=' +
					orderedPlans[byMonth ? 0 : 1].id
				}
				className="purchase-button"
			>
				<p>{buttonText}</p>
			</a>
		);
	};

	const currentProduct = subscribedTo.product === product.product.name;

	return (
		<div className="flex-4">
			<div
				className={
					'price-card card-style' +
					(currentProduct ? ' cta-border' : '')
				}
			>
				<div className="title">{product.product.name}</div>
				<img src={product.product.images[0]} className="image" />
				<div className="description">{product.product.description}</div>

				<div className="tag-holder">
					{popular ? (
						<div className="popular-tag">Popular</div>
					) : null}
				</div>
				<div
					className={
						'price-row-container' +
						(product.product.metadata.kind === 'sc_professional'
							? ' invisible'
							: '')
					}
				>
					<div
						className={'price-column' + (byMonth ? ' active' : '')}
					>
						<div className="price">
							{'$' + orderedPlans[0].amount / 100}
						</div>
						<span className="medium-only">/month</span>
						<div className="billed-desc small-only">
							BILLED
							<span style={{ fontWeight: 'bold' }}> MONTHLY</span>
						</div>
					</div>

					<div className="price-column" style={{ flex: '0.5' }}>
						or
					</div>

					<div
						className={'price-column' + (byMonth ? '' : ' active')}
					>
						<div className="price">
							{'$' + orderedPlans[1].amount / 1200}
						</div>
						<span>/month</span>
						<div className="billed-desc">
							BILLED
							<span style={{ fontWeight: 'bold' }}> YEARLY</span>
						</div>
						{info ? (
							<div className="info-tag medium-only">
								<InfoIcon text={info} left={true} />
							</div>
						) : (
							<div />
						)}
					</div>
				</div>

				<Button />
				<div
					className="details-drop accordion"
					onClick={toggleDropDown}
				>
					<span>View details</span>
					<div className={dropDown ? 'arrow active' : 'arrow'} />
				</div>
				<div className={dropDown ? 'dropdown active' : 'dropdown'}>
					{subscriptionFeatures.map((feature, index) => {
						if (index === 0) {
							return (
								<InfoRow
									feature={feature}
									bold={true}
									partial={subscriptionFeaturesIndex}
									index={index}
									key={index}
								/>
							);
						}
						return (
							<InfoRow
								feature={feature}
								bold={false}
								partial={subscriptionFeaturesIndex}
								index={index}
								key={index}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default PriceCard;
